<script>
	import { totalRecords } from "src/store/store";
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";
	import { statusMapStr } from "src/utils/options";
	import { navigate } from "svelte-routing";
	import { DropdownItem, Table } from "sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import JobConfirmationModal from "../../../components/JobConfirmationModal/JobConfirmationModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import LoaderContainerSort from "../../../components/Loader/LoaderContainerSort.svelte";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";
	import { convert } from "../../../services/helpers";
	import { setJobAction } from "../JobConfirmation";
	export let data;
	export let lookups;
	export let handleDelete;
	export let trigerSelectActiveJob;
	export let triggerPrioritySort;
	export let fetchData;
	export let hasOtherKeys = false;
	export let filterErrorMsg = "";
	export let pastTable = false;
	export let sortDir = 1; // 1 for descending, 0 for ascending
</script>

<LoaderContainer>
	{#if hasOtherKeys && data.length === 0}
		<div
			class="d-flex flex-column justify-content-center align-items-center w-100 py-5 my-5"
		>
			<div class="my-2">
				<b>No results were found.</b>
			</div>
			<div class="my-2">
				<span>{filterErrorMsg}</span>
			</div>
		</div>
	{:else}
		<LoaderContainerSort />
		<Table responsive hover>
			<thead>
				<tr>
					<th>Job ID</th>
					<th>Vehicle No</th>
					<th>Region &nbsp; </th>
					<th>Estate &nbsp; </th>
					<th>Tasks</th>
					<th
						>Priority &nbsp;
						<button
							style="border: none; background-color: transparent;"
							on:click={triggerPrioritySort}
							>{#if sortDir === 1}
								<!--descending order from high to low-->
								<img
									src="/assets/icon-sort-up-thin.svg"
									alt="icon-sort-up"
								/>
							{:else}
								<img
									src="/assets/icon-sort-down-thin.svg"
									alt="icon-sort-down"
								/>
							{/if}
						</button></th
					>
					<th>Mobile No</th>
					<th>Status</th>
					{#if pastTable}
						<th>Reason</th>
					{/if}
					<th>Start date</th>
					<th>Due date</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				{#each data as { id, job, assignedUser, vehicle }}
					<tr>
						<td>
							<span
								class="link link-text"
								on:keydown={() => {}}
								on:click={() => navigate(`/jobs/details/${id}`)}
							>
								{job.code}
							</span>
						</td>
						<td>
							<span
								class="link link-text"
								on:keydown={() => {}}
								on:click={() =>
									navigate(
										`/car-management/details/${vehicle.id}`
									)}
							>
								{vehicle.plateNo}
							</span>
						</td>
						<td>{splitCamelCaseAndCapitalize(vehicle.region)}</td>
						<td>{vehicle.estate}</td>
						<td class="category-container">
							<span class="category-text">
								{#each job.categoryIds.slice(0, 3) as categoryId, index}
									{lookups.presetTasks.find(
										(task) => task.id === categoryId
									)?.description ||
										"-"}{#if index < Math.min(2, job.categoryIds.length - 1)},&nbsp;{/if}
								{/each}
								{#if job.categoryIds.length > 3}...{/if}
								{#if job.categoryIds.length > 3}
									<ul class="category-tooltip">
										{#each job.categoryIds as categoryId, index}
											<li>
												{lookups.presetTasks.find(
													(task) =>
														task.id === categoryId
												).description || "-"}
											</li>
										{/each}
									</ul>
								{/if}
							</span>
						</td>
						<td>{job.priority}</td>
						<td>{assignedUser ? assignedUser?.mobileNo : "-"}</td>
						<td>{@html statusMapStr[job.status]}</td>
						{#if pastTable}
							<td>{job.reason ? job.reason : "-"}</td>
						{/if}
						<td>{convert(job.start)}</td>
						<td>{convert(job.due)}</td>
						<td>
							<TableDropdown>
								<DropdownItem
									on:click={() =>
										navigate(`/jobs/details/${id}`)}
								>
									View Job
								</DropdownItem>
								<DropdownItem
									on:click={() =>
										setJobAction("complete", id)}
								>
									Complete Job
								</DropdownItem>
								<DropdownItem
									on:click={() => setJobAction("delete", id)}
								>
									Delete Job
								</DropdownItem>
							</TableDropdown>
						</td>
					</tr>
				{/each}
			</tbody>
		</Table>
		{#if data.length === 0}
			<p class="text-center">No data to display</p>
		{/if}
		<Pagination totalRecord={$totalRecords} {trigerSelectActiveJob} />
	{/if}
</LoaderContainer>
<JobConfirmationModal {fetchData} />

<style>
	.category-container {
		position: relative;
	}

	.category-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.category-tooltip {
		visibility: hidden;
		width: fit-content;
		background-color: black;
		color: #fff;
		text-align: left;
		border-radius: 6px;
		padding: 5px 20px;
		position: absolute;
		z-index: 1;
		top: 50%; /* Position the tooltip above the text */
		left: 50%;
		margin-left: -60px;
		opacity: 0;
		transition: opacity 0.3s;
	}

	.category-container:hover .category-tooltip {
		visibility: visible;
		opacity: 1;
	}

	button.delete,
	button.complete {
		background: none;
		border: none;
		color: #dc3545;
		cursor: pointer;
		font-size: 18px;
	}

	td {
		white-space: nowrap;
	}
</style>
